import moment from 'moment';
import partnerInfo from '~/mixins/partnerInfo';

const serviceIds = {
  videotherapy: {
    cs: '67b87c6bb2f1907e948548cc',
    en: '685a46caa87a63f0ca2f8813'
  },
  videocall: {
    hu: '674f03012ff2c631c3b982ad',
    en: '67d826e96fd7dd18bbdbf923',
    cs: '64ec747a1e2d0b19390afbce'
  }
};

export default {
  mixins: [partnerInfo],
  data() {
    return {
      currentDate: moment(),
      selectedDate: null,
      selectedTime: null,
      availableTimes: [],
      freeDays: [],
      monthData: {},
      currentMonth: '',
      buttonDisabled: true,
      resource_id: null,
      slot_id: null,
      months: this.$t('videocall.month'),
      buttonLoading: false
    };
  },
  computed: {
    serviceId() {
      const dfn = this.$route.query.dfn;
      const locale = this.$i18n.locale;
      const ids = serviceIds[dfn] || serviceIds.videocall;
      return ids[locale] || ids.cs;
    },
    isVideotherapy() {
      return this.$route.query.dfn === 'videotherapy';
    },
    languageHack() {
      return this.$i18n.locale === 'hu' ? 'ZH' : this.$i18n.locale;
    },
    customer() {
      return {
        firstName: this.$auth.user.firstName,
        lastName: this.$auth.user.lastName,
        email: this.$auth.user.email,
        phone: this.$auth.user.phone,
        partnerName: this.partnerData?.name,
        partnerId: this.partnerData.id,
        partnerRegion: this.partnerData?.region,
        locale: this.languageHack
      };
    },
    daysInMonth() {
      const current = this.currentDate.clone();
      const startOfMonth = current.clone().startOf('month');
      const startDay = (startOfMonth.day() + 6) % 7;
      const count = current.daysInMonth();
      const days = [];
      const today = moment().startOf('day');

      for (let iter = 0; iter < startDay; iter++) {
        days.push({ day: '', isFree: false });
      }

      for (let iter = 1; iter <= count; iter++) {
        const date = current.clone().date(iter);
        const isPast = date.isBefore(today, 'day');
        const isFree = !isPast && this.freeDays.includes(date.format('YYYY-MM-DD'));
        days.push({ day: iter, date: date.format('YYYY-MM-DD'), isFree });
      }

      return days;
    }
  },
  methods: {
    apiProxyRequest(config) {
      return this.$http.post('/v3/remote-api-proxy', config);
    },
    fetchMonthData(startDate, endDate) {
      return this.apiProxyRequest({
        method: 'POST',
        service: 'appointedd',
        endpoint: '/v1/availability/intervals/search',
        data: {
          spaces: 1,
          timezone: 'Europe/Prague',
          ignore_past_restriction: false,
          ignore_notice_restriction: false,
          ignore_service_assignment: false,
          ignore_service_schedule: false,
          ignore_group_setting: false,
          ignore_block_restriction: false,
          service_id: this.serviceId,
          ranges: [{ start: startDate, end: endDate }]
        }
      });
    },
    reserveBookingSlot(start) {
      return this.apiProxyRequest({
        method: 'POST',
        service: 'appointedd',
        endpoint: '/v1/availability/slots',
        data: {
          data: {
            resource_id: this.resource_id,
            service_id: this.serviceId,
            start: start
          }
        }
      });
    },
    createBooking(slot_id) {
      return this.apiProxyRequest({
        method: 'POST',
        service: 'appointedd',
        endpoint: '/v1/bookings',
        data: {
          timezone: 'Europe/Prague',
          send_payment_request: false,
          slot_id: slot_id,
          data: {
            created_source: 'api',
            customers: [
              {
                customer: {
                  profile: {
                    firstname: this.customer.firstName,
                    lastname: this.customer.lastName,
                    email: this.customer.email,
                    mobile: this.customer.phone
                  },
                  custom_fields: [
                    { id: 'webuser_email', value: this.customer.email },
                    { id: 'partner_name', value: this.customer.partnerName },
                    { id: 'partner_id', value: this.customer.partnerId },
                    { id: 'partner_region', value: this.customer.partnerRegion }
                  ]
                },
                locale: this.customer.locale,
                total_spaces: 1
              }
            ]
          }
        }
      });
    },
    loadMonthData() {
      const startOfMonth = this.currentDate
        .clone()
        .startOf('month')
        .format('YYYY-MM-DDTHH:mm:ss[Z]');
      const endOfMonth = this.currentDate.clone().endOf('month').format('YYYY-MM-DDTHH:mm:ss[Z]');
      const monthKey = this.currentDate.clone().format('YYYY-MM');

      if (this.monthData[monthKey]) {
        this.updateFreeDaysAndTimes(monthKey);
        this.autoSelectFirstAvailableDay();
        return;
      }

      this.fetchMonthData(startOfMonth, endOfMonth)
        .then(data => {
          const monthDates = {};
          data.data.forEach(interval => {
            const date = moment(interval.start).format('YYYY-MM-DD');
            const time = moment(interval.start).format('HH:mm');
            if (!monthDates[date]) {
              monthDates[date] = { times: [], resource_ids: [] };
            }
            monthDates[date].times.push(time);
            monthDates[date].resource_ids.push(...interval.resource_ids);
          });
          this.monthData[monthKey] = monthDates;
          this.updateFreeDaysAndTimes(monthKey);
          this.autoSelectFirstAvailableDay();
        })
        .catch(err => console.error(err));
    },
    updateFreeDaysAndTimes(monthKey) {
      const monthDates = this.monthData[monthKey];
      this.freeDays = Object.keys(monthDates);
      if (this.selectedDate && monthDates[this.selectedDate]) {
        this.availableTimes = monthDates[this.selectedDate].times;
      } else {
        this.availableTimes = [];
      }
    },
    autoSelectFirstAvailableDay() {
      if (this.freeDays.length > 0) {
        this.selectedDate = this.freeDays[0];
        this.updateAvailableTimes();
      }
    },
    updateAvailableTimes() {
      const monthKey = this.currentDate.format('YYYY-MM');
      if (this.monthData[monthKey][this.selectedDate]) {
        this.availableTimes = this.monthData[monthKey][this.selectedDate].times;
      }
    },
    selectDate(day) {
      this.buttonDisabled = true;
      if (!day.isFree) {
        return;
      }
      this.selectedDate = day.date;
      this.updateAvailableTimes();
      this.selectedTime = null;
    },
    selectTime(time) {
      this.buttonDisabled = false;
      this.selectedTime = time;

      const monthKey = this.currentDate.format('YYYY-MM');
      this.resource_id = this.monthData[monthKey][this.selectedDate]?.resource_ids[0] || null;
    },
    confirmSelection() {
      this.buttonLoading = true;
      const start = moment(`${this.selectedDate}T${this.selectedTime}`).format();
      this.reserveBookingSlot(start)
        .then(data => {
          this.slot_id = data.data.id;
          this.createBooking(this.slot_id)
            .then(() => {
              this.$emit('next-click');
              this.sendAnalyticsUl({
                activity: `${this.$route.query.dfn}_planned`,
                partner_id: this.partnerId,
                partner_name: this.partnerName,
                delaySeconds: 4
              });
              this.buttonLoading = false;
            })
            .catch(err => console.log(err));
        })
        .catch(err => console.error(err));
    },
    prevMonth() {
      if (this.currentDate.isSame(moment(), 'month')) {
        return;
      }
      this.currentDate = this.currentDate.clone().subtract(1, 'month');
      this.selectedDate = null;
      this.selectedTime = null;
      this.currentMonth = this.months[this.currentDate.month()] + ' ' + this.currentDate.year();
      this.loadMonthData();
    },
    nextMonth() {
      this.currentDate = this.currentDate.clone().add(1, 'month');
      this.selectedDate = null;
      this.selectedTime = null;
      this.currentMonth = this.months[this.currentDate.month()] + ' ' + this.currentDate.year();
      this.loadMonthData();
    }
  },
  mounted() {
    this.currentMonth = this.months[this.currentDate.month()] + ' ' + this.currentDate.year();
    this.loadMonthData();
  }
};
